import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import { RoundButton } from 'ui/Buttons';

const SectionTitle = ({ label, ratingType, onChangeTabs }) => {
  const { t } = useTranslation();

  return (
    <Grid container justifyContent="space-between">
      <Grid item xs={10}>
        <Typography variant="h5">{label}</Typography>
      </Grid>
      <Grid item xs={2}>
        <Grid container justifyContent="flex-end">
          <RoundButton
            onClick={() => {
              onChangeTabs('companyModule', ratingType);
            }}
            label={t('View more')}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

SectionTitle.propTypes = {
  label: PropTypes.string.isRequired,
  ratingType: PropTypes.string.isRequired,
  onChangeTabs: PropTypes.func.isRequired,
};

export { SectionTitle };
